import { LIBRARY_SECTIONS_PATH } from '@/consts/urls';
import { fetchLibraryData } from './utils';

import type { LibraryItem, LibrarySection } from '@/types';

type ResponseType = {
  data: {
    title: string;
    slug: string;
    items: LibraryItem[];
  }[];
};

/**
 * Batch fetch of every library section (tabs + items) in one request via
 * GET /hubs/:key/grids/flow, replacing the former tabs call plus one
 * /grids/:slug/flow call per category.
 */
const getLibrarySections = async (): Promise<LibrarySection[] | null> => {
  return fetchLibraryData({
    path: LIBRARY_SECTIONS_PATH,
    transform: (response) => {
      const data = response as ResponseType;
      if (!data?.data) return null;
      return data.data.map((section) => ({
        title: section.title,
        slug: section.slug,
        items: section.items?.filter((item) => item.media != null) ?? [],
      }));
    },
  });
};

export default getLibrarySections;
